export const HEADER_7_CONSTANTS = {
  METADATA_TITLES: {
    metadata: "Dynamic widgets",
  },

  DEFAULT_ROW: {
    id: "1",
    widget_label: "",
    widget_value: "",
    widget_link: "",
    priority: 1,
    status: true,
  },

  METADATA_FIELDS: [
    {
      header: "Label",
      fieldName: "widget_label",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. Phone No.",
    },
    {
      header: "Value",
      fieldName: "widget_value",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Text shown (e.g. +91 1800 210 2020)",
    },
    {
      header: "Link",
      fieldName: "widget_link",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Optional href (e.g. tel:+9118002102020 or https://…)",
      required: false,
    },
    {
      header: "Priority",
      fieldName: "priority",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Sort order (lower first)",
      required: false,
      defaultValue: 1,
    },
    {
      header: "Row status",
      fieldName: "status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Show this widget",
      defaultValue: true,
    },
  ],

  HEADER_FIELDS_CONFIG: [
    {
      fieldName: "background_color",
      label: "Bar background color",
      value: "#291973",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "e.g. #291973",
      required: false,
      defaultValue: "#291973",
    },
    {
      fieldName: "pill_background_color",
      label: "Widget pill / chip background",
      value: "rgba(255, 255, 255, 0.1)",
      valueType: "string",
      filedType: "RGBA",
      placeholder: "e.g. rgba(255,255,255,0.1)",
      required: false,
      defaultValue: "rgba(255, 255, 255, 0.1)",
    },
    {
      fieldName: "label_text_color",
      label: "Widget label text color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "phone_text_color",
      label: "Widget value text color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "show_logo",
      label: "Show logo (left side)",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      required: false,
      defaultValue: false,
    },
    {
      fieldName: "logo_image",
      label: "Logo image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload logo shown on the left when Show logo is on",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "whatsapp_show",
      label: "Show WhatsApp pill (right side)",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      required: false,
      defaultValue: true,
    },
    {
      fieldName: "whatsapp_number",
      label: "WhatsApp number",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Digits only with country code (e.g. 919876543210)",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "whatsapp_link",
      label: "WhatsApp link (optional override)",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Leave empty to build from the number above",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "whatsapp_button_text",
      label: "WhatsApp button text",
      value: "WhatsApp Chat",
      valueType: "string",
      filedType: "INPUT",
      required: false,
      defaultValue: "WhatsApp Chat",
    },
    {
      fieldName: "whatsapp_button_color",
      label: "WhatsApp button color",
      value: "#4CAF51",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#4CAF51",
    },
    {
      fieldName: "whatsapp_button_text_color",
      label: "WhatsApp button text color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "whatsapp_icon",
      label: "WhatsApp icon (optional)",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Overrides the default WhatsApp glyph when set",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "button_name",
      label: "CTA button text (right side)",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Leave empty to hide the CTA button",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "button_link",
      label: "CTA button link",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. /apply or https://…",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "button_color",
      label: "CTA button background color",
      value: "",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Empty = white",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "button_text_color",
      label: "CTA button text color",
      value: "",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Empty = bar color (#291973)",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "show_on_mobile",
      label: "Show on mobile (default: large screens only)",
      value: false,
      valueType: "boolean",
      filedType: "SWITCH",
      required: false,
      defaultValue: false,
    },
    {
      fieldName: "sticky_to_top",
      label: "Stick to top on scroll",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      required: false,
      defaultValue: false,
    },
    {
      fieldName: "status",
      label: "Status",
      value: true,
      valueType: "boolean",
      filedType: "SWITCH",
      placeholder: "Toggle status",
      required: false,
      defaultValue: true,
    },
  ],
};
